module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-warning btn-sm",
    attrs: {
      "href": _vm.formLink(),
      "target": "_blank"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.linkMessage) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d50a956","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/OpenOnSiteButton.vue
// module id = 893
// module chunks = 0